module.exports = __webpack_public_path__ + "img/bg.64635a43.png";